import { Row, Tooltip, DatePicker, Label } from 'components/Blocks';

import { InfoIcon } from 'components/Icons';

import { FormControlHook } from 'hooks';

import { getDateToLocaleStartOfDay } from 'utils/date';

interface InvoiceDateProps extends Pick<FormControlHook<{ date: string | null }>, 'state'> {
  children?: never;
  label: string;
  helperText: string;
  dispatch: (data: { date: string | null }) => void;
}

export function InvoiceDate({ state, dispatch, helperText, label }: InvoiceDateProps) {
  const handleDateChange = (date: Date | undefined): void => {
    if (!date) return;

    dispatch({
      date: getDateToLocaleStartOfDay(date),
    });
  };

  const { date } = state;

  return (
    <Row justifyContent="space-between">
      <Row gap="2">
        <Label>{label}</Label>

        <Tooltip content={helperText} position="right" ensurePresence>
          <InfoIcon size={18} color="primary" />
        </Tooltip>
      </Row>

      <DatePicker
        disableFuture
        selected={date ? new Date(date) : undefined}
        onSelect={handleDateChange}
      />
    </Row>
  );
}
